import { P as Pubsub } from './pubsub-DKqIEqaC.js';
import './notyf-DIw0RvBj.js';
import { f as fetchHTML } from './fetchHTML-9PhJW9Dj.js';

class ProductGrid extends HTMLElement {
  unsubscribers = [];
  html;
  section = this.closest('section');

  connectedCallback() {
    this.unsubscribers.push(
      Pubsub.subscribe('sort:changed', () => this.fetchSection()),
      Pubsub.subscribe('filters:updated', () => this.fetchSection())
    );
  }

  disconnectedCallback() {
    this.unsubscribers.forEach((unsubscriber) => unsubscriber());
  }

  async fetchSection() {
    this.abortController?.abort();
    this.abortController = new AbortController();

    const searchParams = new URLSearchParams(window.location.search);
    let url = `${window.location.pathname}?section_id=${this.id}`;
    if (searchParams.size > 0) url += `&${searchParams}`;

    try {
      this.html = await fetchHTML(url);

      this.replaceGrid();
      this.updateProductCount();
    } catch (error) {
      console.error(error);
    }
  }

  replaceGrid() {
    const fetchedGrid = this.html.querySelector('product-grid');
    this.innerHTML = fetchedGrid.innerHTML;
  }

  updateProductCount() {
    const productCountElement = this.section.querySelector('[data-product-count]');
    const resultsCount = this.html.querySelector('[data-product-count]');

    productCountElement.replaceWith(resultsCount);
  }
}

customElements.define('product-grid', ProductGrid);
